<div>
    <app-form-editorrights
        [groupList]="groupList"
        [userList]="userList"
        [customEditorList]="customEditorList"
        (onValidate)="validate($event)"
        (onCancel)="cancel()"
    >
    </app-form-editorrights>
</div>
